import { render } from "./OrganizerDashboardIndex.vue?vue&type=template&id=6c5ef23f&scoped=true"
import script from "./OrganizerDashboardIndex.vue?vue&type=script&lang=js"
export * from "./OrganizerDashboardIndex.vue?vue&type=script&lang=js"

import "./OrganizerDashboardIndex.vue?vue&type=style&index=0&id=6c5ef23f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5ef23f"]])

export default __exports__